<template>
	<highcharts :options="reformatOptions"></highcharts>
</template>
<script>
import ChartHelper from 'Mixins/ChartHelper'
export default {
	name: 'MPieChart',
	/* eslint-disable */
	props: ['options', 'data'],
	/* eslint-enable */
	mixins: [ChartHelper],
	created() {
		document.addEventListener('DOMContentLoaded', function() {
			const credit = document.getElementsByClassName('highcharts-credits')
			credit[0].remove()
		})
	},
	data() {
		return {}
	},
	computed: {
		reformatOptions() {
			let roast = this.roastV2(this.options, this.data)
			let size = null
			roast.title['align'] = 'left'
			roast.title['margin'] = 15
			roast.subtitle['align'] = 'left'

			if ('series' in roast) {
				roast.series[0]['turboThreshold'] = 0
				roast.series[0]['allowPointSelect'] = false
			}

			if ('size' in this.options) {
				size = this.options.size
			}

			let chartOptions = {
				...roast,
				chart: {
					type: 'pie',
					polar: false,
					style: {
						fontFamily:
							'"Lucida Grande", "Lucida Sans Unicode", Verdana, Arial, Helvetica, sans-serif',
						color: '#333',
						fontSize: '12px',
						fontWeight: 'normal',
						fontStyle: 'normal'
					},
					spacingBottom: 30,
					spacingLeft: 30,
					spacingRight: 30,
					spacingTop: 30
				},
				plotOptions: {
					pie: {
						allowPointSelect: true,
						cursor: true,
						showInLegend: true,
						dataLabels: {
							enabled: false
						},
						size
					},
					series: {
						animation: false
					}
				},
				// series: [
				// 	{
				// 		name: 'value',
				// 		turboThreshold: 0,
				// 		allowPointSelect: false
				// 	}
				// ],
				colors: [
					'#95B9E9',
					'#F2BE69',
					'#4987D9',
					'#f7a35c',
					'#8085e9',
					'#f15c80',
					'#e4d354',
					'#2b908f',
					'#f45b5b',
					'#91e8e1'
				],
				legend: {
					enabled: true,
					align: 'right',
					reversed: false,
					layout: 'vertical',
					verticalAlign: 'top',
					squareSymbol: true,
					labelFormat: '',
					itemDistance: 0,
					itemMarginTop: 0,
					itemMarginBottom: 0,
					x: 0,
					y: 50,
					itemStyle: {
						fontFamily:
							'"Lucida Grande", "Lucida Sans Unicode", Verdana, Arial, Helvetica, sans-serif',
						color: '#333333',
						fontSize: '14px',
						fontWeight: 'normal',
						fontStyle: 'normal',
						cursor: 'pointer'
					}
				}
			}
			return chartOptions
		}
	}
}
</script>
